<template>
	<Popup
		v-model="selfDisplay"
		title="上传数据"
		:expandBtnDisplay="true"
		expandBtnText="下载预览"
		confirmBtnText="保存"
		@expandClick="handleDownloadClick"
		@confirmClick="handleAddClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>上传excel</span>
				<div v-if="!excel" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" @change="handleExcelUpload"/>
					<span class="b_upload_tip">请上传excel文件！！！</span>
				</div>
				<div v-if="excel" class="b_inline_block" style="line-height: 36px;">
					{{ excel.split('/')[excel.split('/').length - 1] }}
				</div>
				<i v-if="excel" class="el-icon-circle-close" style="margin-left: 10px;color: #F56C6C;line-height: 36px;cursor: pointer;" @click="handleDeleteClick"></i>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="excelTip"><i class="b_icon"></i>请上传excel文件</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../api/index.js';
	import BaseMethods from '../../../../../../assets/js/base.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				excel: '',
				excelTip: false
			}
		},
		methods: {
			// 上传excel
			handleExcelUpload(e) {
				const that = this;
				that.loading = true;
				BaseMethods.uploadFile(e, 'xlsx', (data) => {
					Api.uploadFile(data).then(res => {
						that.loading = false;
						that.excel = res.data.data;
					},e => {
						that.loading = false;
						that.$message.error(e.message);
					});
				}, (msg) => {
					that.loading = false;
					that.$message.error(msg);
				});
			},
			// 点击删除
			handleDeleteClick() {
				this.excel = '';
			},
			// 点击下载预览
			handleDownloadClick() {
				this.excel ? window.open(this.excel) : this.$message.warning('请上传excel文件');
			},
			// 点击保存
			handleAddClick() {
				const that = this;
				if (!that.excel) {
					that.excelTip = true;
					return false;
				} else {
					that.excelTip = false;
				}
				that.loading = true;
				var requestData = {
					rechargeExcel: that.excel
				};
				Api.addExcel(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.loading = false;
					this.excel = '';
					this.excelTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
